import { Link, useHistory, useLocation, useParams } from 'react-router-dom';

import { BaseURL } from '../../../base/env';
import sub_no_name from './../../../assets/images/icons/sub-no-name.png';
import { ReactComponent as BottomArrow } from './../../../assets/svg/bottom-arrow.svg';
import styles from './CategoryBar.module.css';
import FilterSort from './FilterSort/FilterSort';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const CategoryBar = ({
  categories,
  page = '',
  showFilterSort = false,
  activeCategory,
  setActiveCategory,
  withoutUrl
}) => {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  if (!categories) {
    return null;
  }

  const paramsArray = getSortedParams(params);

  const SubList = categories.find((catItem) => {
    if (withoutUrl) {
      return catItem.id.toString() === (activeCategory || '').toString();
    }
    return catItem.id.toString() === paramsArray[paramsArray.length - 2];
  });

  if (!SubList || !SubList.sub_categories) {
    return null;
  }

  // const categoryHomePages = localStorage.getItem("page_type") === "category_home_page" ? true : false

  return (
    <div className={styles.CategoryBarContainer}>
      {categories ? (
        <div className={`${styles.ParentListContainer}`}>
          <div className={styles.ParentList}>
            {withoutUrl
              ? categories.map((pitem) => {
                  const isActive = activeCategory.toString() === pitem.id.toString();
                  return (
                    <button
                      key={pitem.id}
                      // TODO : this to={} must be correct for snappcarfix. it is correct just
                      // to={ categoryHomePages ?  paramsArray.length < 2 ? `/category/${pitem.id.toString()}` : `/category/1/${pitem.id.toString()}` : paramsArray.length < 2 ? `/category/${pitem.id.toString()}/${pitem.id.toString()}` : `/category/1/${pitem.id.toString()}/${pitem.id.toString()}`}
                      className={`${styles.ParentItem} ${isActive ? styles.Active : ''}`}
                      onClick={() => setActiveCategory(pitem.id.toString())}
                      type="button">
                      {pitem.name}
                    </button>
                  );
                })
              : // TODO: must be work not jus in carfillo but in snapp carfix when we have more than one main category
                categories[0].sub_categories.map((sitem) => {
                  const subParamsArray = getSortedParams(params);
                  const isActive =
                    subParamsArray[subParamsArray.length - 1].toString() === sitem.id.toString();
                  if (subParamsArray.length <= 2 && sitem.name === 'همه') {
                    return null;
                  }
                  subParamsArray[subParamsArray.length - 1] = sitem.id;
                  const newUrl = `/${page}${subParamsArray.map((pitem) => `/${pitem}`).join('')}`;
                  return (
                    <Link
                      key={sitem.id}
                      className={`${styles.ParentItem} ${isActive ? styles.Active : ''}`}
                      to={newUrl}>
                      {sitem.name}
                    </Link>
                  );
                })}
          </div>
        </div>
      ) : null}
      {categories ? (
        <div className={`${styles.SubListContainer} ${!withoutUrl ? styles.HasReturn : ''}`}>
          <div className={styles.SubList}>
            {SubList.sub_categories.map((subItem) => {
              const isActive = withoutUrl
                ? false
                : paramsArray[paramsArray.length - 2].toString() === subItem.id.toString();
              const subParamsArray = getSortedParams(params);
              if (subParamsArray.length <= 1 && subItem.name === 'همه') {
                return null;
              }
              if (subItem.has_sub_categories && !withoutUrl) {
                subParamsArray.push(subItem.id.toString());
              } else if (!withoutUrl) {
                subParamsArray[subParamsArray.length - 1] = subItem.id.toString();
              } else if (withoutUrl) {
                subParamsArray.length === 0
                  ? subParamsArray.push('1', subItem.id.toString())
                  : subParamsArray.push(subItem.id.toString());
              }
              const newUrl = `/category${subParamsArray.map((pitem) => `/${pitem}`).join('')}`;

              return (
                <Link key={subItem.id} className={styles.SubItem} to={newUrl}>
                  <div
                    className={`${styles.SubItemImageContainer} ${isActive ? styles.Active : ''}`}>
                    <img
                      alt={subItem.name}
                      className={styles.SubItemImage}
                      src={subItem.image ? BaseURL + subItem.image : sub_no_name}
                    />
                  </div>
                  <span className={styles.SubItemText}>{subItem.name}</span>
                </Link>
              );
            })}
          </div>

          {/* Back Butoton */}
          <div
            className={`${styles.BackContainer} ${!withoutUrl ? styles.Active : ''}`}
            onClick={() => {
              if (paramsArray.length > 3) {
                const subParamsArray = getSortedParams(params);
                subParamsArray.pop();
                const newUrl = `/${page}${subParamsArray.map((pitem) => `/${pitem}`).join('')}${location.search}`;
                history.push(newUrl);
              } else {
                history.push('/');
              }
            }}>
            <BottomArrow className={styles.BottomArrow} />
          </div>
        </div>
      ) : null}
      {!!showFilterSort && !!activeCategory ? <FilterSort category_id={activeCategory} /> : null}
    </div>
  );
};

export default CategoryBar;
